import { render, staticRenderFns } from "./AllSDCampaignRequestContact.vue?vue&type=template&id=04ecd5da&scoped=true"
import script from "./AllSDCampaignRequestContact.vue?vue&type=script&lang=js"
export * from "./AllSDCampaignRequestContact.vue?vue&type=script&lang=js"
import style0 from "./AllSDCampaignRequestContact.vue?vue&type=style&index=0&id=04ecd5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ecd5da",
  null
  
)

export default component.exports